import {
  parseCep,
  parseCpf,
  parseRg,
  parseTelefone
} from '../../../utils/Parse'

export const formatMotorista = (motorista, values) => ({
  ...motorista,
  cpf: parseCpf(motorista.cpf),
  rg: parseRg(motorista.rg),
  cpfMae: parseCpf(motorista.cpfMae),
  cpfPai: parseCpf(motorista.cpfPai),
  cep: parseCep(motorista.cep),
  telefone: parseTelefone(motorista.telefone),
  id: values.motorista ? values.motorista.id : undefined,
  cnhImage: values.motorista ? values.motorista.cnhImage : undefined,
  foto: values.motorista ? values.motorista.foto : undefined
})
